import React from 'react';
import PropTypes from 'prop-types';
import defaultLogo from 'assets/images/logos/defaultlogo.png';

const RoleSelectionModel = ({ organizations, onSelect }) => {
    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex justify-center items-center backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 border border-gray-100">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mx-auto mb-4 flex items-center justify-center">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h1a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-2">Select Your Organization</h2>
                    <p className="text-gray-600 text-sm">Choose your organization to continue</p>
                </div>

                <div className="space-y-4 max-h-96 overflow-y-auto">
                    {organizations.map((org, index) => (
                        <div key={index}>
                            <button
                                onClick={() => {
                                    localStorage.setItem('selectedOrganization', JSON.stringify(org));
                                    onSelect(org);
                                }}
                                className="w-full bg-white border border-gray-200 rounded-xl shadow hover:shadow-md transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            >
                                <div className="flex items-center p-4 space-x-4">
                                    <img
                                        src={org.organization?.orgImage?.secure_url || defaultLogo}
                                        alt={`${org.organization.name} Logo`}
                                        className="w-12 h-12 rounded-full object-cover"
                                    />
                                    <div className="text-left">
                                        <div className="font-semibold text-gray-800 text-base">
                                            {org.organization?.name || `Organization ${index + 1}`}
                                        </div>
                                        <div className="text-sm text-gray-600 mt-1">{org.name}</div>
                                    </div>
                                </div>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

RoleSelectionModel.propTypes = {
    organizations: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
};
export default RoleSelectionModel;

